import { BodyText, Tag, IconPropsStrict, Icon } from '@servicetitan/design-system';
import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import * as Styles from './filter-tag.module.less';

export interface FilterTagProps {
    className?: string;
    active?: boolean;
    disabled?: boolean;
    count?: number;
    leftIconName?: IconPropsStrict['name'];
    rightIconName?: IconPropsStrict['name'];
    size?: 's' | 'm';
    children?: ReactNode;
    onClick?(): void;
}

export const FilterTag: FC<FilterTagProps> = ({
    active,
    children,
    className,
    count,
    disabled,
    leftIconName,
    onClick,
    rightIconName,
    size = 'm',
}) => {
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    const isActive = active !== undefined ? active : !!count;

    return (
        <div
            className={classNames(
                {
                    [Styles.containerS]: size === 's',
                    [Styles.containerM]: size === 'm',
                    [Styles.containerDisabled]: disabled,
                },
                'border-radius-pill d-if flex-row align-items-center cursor-pointer',
                { 'bg-purple-100': isActive, [Styles.containerNotActive]: !isActive },
                className
            )}
            onClick={onClick}
        >
            {!!leftIconName && (
                <Icon className={classNames({ 'm-r-1': !!children })} name={leftIconName} />
            )}

            {typeof children === 'string' ? (
                <BodyText size="small" className={classNames({ 'c-purple-600': isActive })}>
                    {children}
                </BodyText>
            ) : (
                children
            )}

            {!!count && (
                <Tag compact badge color="info" className="m-l-1">
                    {count}
                </Tag>
            )}
            {!!rightIconName && <Icon className="m-l-half" name={rightIconName} />}
        </div>
    );
};
